import React, { useEffect, useState } from "react";
import { DateTime, Interval } from "luxon";
import styled from "styled-components";
import { colors, shadows } from "../../../../../../ui";

export const LastReadFC = ({ recent_datetimes }) => {
  const [lastReadArray, setLastReadArray] = useState([]);

  const getFileDatetimes = async () => {
    setLastReadArray(recent_datetimes);
  };

  useEffect(() => {
    getFileDatetimes();
  }, [recent_datetimes]);

  return (
    <>
      {window.screen.width >= 768 ? (
        <>
          {lastReadArray ? (
            <>
              {!lastReadArray.capture_datetime ||
              lastReadArray.process_mag !==
                true ? null : Interval.fromDateTimes(
                  DateTime.fromISO(lastReadArray.capture_datetime),
                  DateTime.now(),
                ).length("hours") >
                (lastReadArray.manufacturer === "Philips" ? 12 : 3) ? (
                <DateTimeBox color={"red"}>
                  <SmallText>MAG: </SmallText>
                  <DateText>
                    {DateTime.fromISO(lastReadArray.capture_datetime).toFormat(
                      "ff",
                    )}
                  </DateText>
                </DateTimeBox>
              ) : (
                <DateTimeBox>
                  <SmallText>MAG: </SmallText>
                  <DateText>
                    {DateTime.fromISO(lastReadArray.capture_datetime).toFormat(
                      "ff",
                    )}
                  </DateText>
                </DateTimeBox>
              )}
              {!lastReadArray.edu_datetime ||
              lastReadArray.process_edu !==
                true ? null : Interval.fromDateTimes(
                  DateTime.fromISO(lastReadArray.edu_datetime),
                  DateTime.now(),
                ).length("hours") > 3 ? (
                <DateTimeBox color={"red"}>
                  <SmallText>ENV: </SmallText>
                  <DateText>
                    {DateTime.fromISO(lastReadArray.edu_datetime).toFormat(
                      "ff",
                    )}
                  </DateText>
                </DateTimeBox>
              ) : (
                <DateTimeBox>
                  <SmallText>ENV: </SmallText>
                  <DateText>
                    {DateTime.fromISO(lastReadArray.edu_datetime).toFormat(
                      "ff",
                    )}
                  </DateText>
                </DateTimeBox>
              )}
            </>
          ) : (
            <SmallText> No Recent File </SmallText>
          )}
        </>
      ) : (
        <>
          {lastReadArray ? (
            <>
              {lastReadArray.capture_datetime && lastReadArray.process_mag ? (
                <DateText>
                  {DateTime.fromISO(lastReadArray.capture_datetime).toFormat(
                    "ff",
                  )}
                </DateText>
              ) : lastReadArray.edu_datetime && lastReadArray.process_edu ? (
                <DateText>
                  {DateTime.fromISO(lastReadArray.edu_datetime).toFormat("ff")}
                </DateText>
              ) : (
                <DateText>No Recent Files</DateText>
              )}
            </>
          ) : (
            <DateText> No Recent Files </DateText>
          )}
        </>
      )}
    </>
  );
};

const DateTimeBox = styled.div`
  color: ${({ color }) =>
    color === "red" ? colors.error.main : colors.neutral[700]};
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  margin: 4px 0;
  border-radius: 12px;
  background: ${({ color }) =>
    color === "red" ? "rgba(231, 76, 60, 0.1)" : "rgba(255, 255, 255, 0.1)"};
  backdrop-filter: blur(12px);
  border: 1px solid
    ${({ color }) =>
      color === "red" ? "rgba(231, 76, 60, 0.3)" : "rgba(255, 255, 255, 0.2)"};

  @media screen and (max-width: 769px) {
    padding: 6px 10px;
    font-size: 0.9em;
  }
`;

const SmallText = styled.div`
  min-width: 55px;
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  color: ${colors.neutral[600]};

  @media screen and (max-width: 769px) {
    min-width: 45px;
    font-size: 11px;
  }
`;

const DateText = styled.div`
  display: inline-block;
  font-size: 13px;
  font-weight: 400;
  color: inherit;

  @media screen and (max-width: 769px) {
    font-size: 12px;
  }
`;
